import React, { SVGProps } from "react";
export default function SupUserAnon013(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 1.92352L10 4.23109M6 1.92352L2 4.23109V8.84621M6 1.92352V4.23109V6.53865M10 4.23109V8.84621M10 4.23109L14 1.92352M10 8.84621L6 11.1538L2 8.84621M10 8.84621L6 6.53865M10 8.84621L14 11.1538L18 8.84621M10 8.84621L14 6.53865M2 8.84621L6 6.53865M14 1.92352L18 4.23109V8.84621M14 1.92352V4.23109V6.53865M18 8.84621L14 6.53865M10 8.84621L14 11.1538V15.7689M10 8.84621L6 11.1538V15.7689M10 8.84621V11.1538V13.4613M14 15.7689L10 18.0765L6 15.7689M14 15.7689L10 13.4613M6 15.7689L10 13.4613"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
